var Dispatcher = require('flux').Dispatcher;
var assign = require('object-assign');

var AppDispatcher = assign(new Dispatcher(), {

  handleViewAction: function(action) {
    this.dispatch({
      source: 'VIEW_ACTION',
      action: action
    });
  },

  handleRequestAction: function(action) {
    this.dispatch({
      source: 'REQUEST_ACTION',
      action: action
    });
  }

});

module.exports = AppDispatcher;



// WEBPACK FOOTER //
// ./app/dispatchers/AppDispatcher.js